import { render } from "./PhoneLinkCompass.vue?vue&type=template&id=c6f15146"
import script from "./PhoneLinkCompass.vue?vue&type=script&lang=js"
export * from "./PhoneLinkCompass.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__